import Footer from '../Shared/Footer';
import AvailableOrders from './AvailableOrders';

const Orders = () => {
    
    return (
        <div>
            <AvailableOrders />
            <Footer />
        </div>
    );
};

export default Orders;